

const AccountProfile = (values) => {
  let configuredPremiumText = values.props.isPremium? "" : " not"; 
  let configuredMarketingText = values.props.isOptInMarketing? "" : " not";
  return (<div style={{'textAlign':'left','marginTop':'2vh'}}><p style={{'fontSize':'20px','paddingBottom':'20px','borderBottom':'4px solid black'}}>Welcome {values.props.username}</p><p>You are<b>{configuredPremiumText}</b> a premium user.</p>
          <p>You are<b>{configuredMarketingText}</b> opted in to receive marketing emails.</p>
          </div>);
}

export default AccountProfile;